import { render } from "./sav-form.vue?vue&type=template&id=76749369"
import script from "./sav-form.vue?vue&type=script&lang=js"
export * from "./sav-form.vue?vue&type=script&lang=js"

import "./sav-form.vue?vue&type=style&index=0&id=76749369&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__